import React from 'react';
interface TikTokIconProps {
  className?: string;
}
export function TikTokIcon({
  className
}: TikTokIconProps) {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" className={className} data-id="element-315" data-mp="2cktg9roqosj3">
      <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-1.85-2.48V9.79a5.67 5.67 0 1 0 4.94 5.61V8.87a7.35 7.35 0 0 0 4.31 1.38V7.16a4.28 4.28 0 0 1-3.25-1.34Z" data-id="element-316" data-mp="22wbiljbrb1jo" />
    </svg>;
}